import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  padding-top: 104px;

  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-y: scroll;
  z-index: 0;
`;

export const FormContainer = styled.div`
  width: 864px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: start;
  padding: 24px;

  ${(props) =>
    props.isFooterDisplayed &&
    css`
      margin-bottom: 56px;
    `}
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: end;
  gap: 16px;
`;
